import createFormContext from '../../context/formContext'

const { FormStateProvider, useStore } = createFormContext({
    id: "",
    loaded: false,
    savedOn: "",
});

export { FormStateProvider, useStore };